export const FETCH_CURRENT_PRIVACY_CONSENTS =
  'app/PrivacyConsents/FETCH_CURRENT_PRIVACY_CONSENTS';
export const FETCH_CURRENT_PRIVACY_CONSENTS_SUCCESS =
  'app/PrivacyConsents/FETCH_CURRENT_PRIVACY_CONSENTS_SUCCESS';
export const FETCH_CURRENT_PRIVACY_CONSENTS_ERROR =
  'app/PrivacyConsents/FETCH_CURRENT_PRIVACY_CONSENTS_ERROR';
